<template>
  <div class="headFixed freshAirDetail eq-panel" @click="hideSomething">
    <div class="detail_head fixed_head">
      <div class="">
        <div class="content">
          <div class="go_back">
            <span @click="goBack" class="goBackBtn"></span>
            {{ eqInfo ? eqInfo.name : '' }}
            <img v-show="eqInfo" @click="changeMenu" class="right menuImg" width="25"
                 src="../../../assets/images/menu.png" alt=""/>
          </div>
        </div>
      </div>
      <div class="menu" v-show="showMenu">
        <ul>
          <router-link :to="'/equipment/info/' + this.getId()">
            <li>设备信息</li>
          </router-link>

          <router-link :to="'/fresh/status4/' + this.getId()">
            <li>设备状态</li>
          </router-link>

          <li @click="eqUnbind">解除绑定</li>
        </ul>
      </div>
    </div>
    <!--    <div class="noInfo" v-show="showEmpty">暂无信息</div>-->
    <div>
      <div class="eqInfoDetail" v-show="eqInfo">
        <div>
          <div class="detail_top">
            <span v-show="eqInfo.airVentilator.workingMode1 === '1'" class="hotBg"></span>
            <span v-show="eqInfo.airVentilator.workingMode1 === '0'" class="coolBg"></span>
            <span v-show="eqInfo.airVentilator.workingMode1 === '2'" class="airBg"></span>
            <div></div>

            <div class="degrees">
              <canvas id="clock" width="220px" height="220px"></canvas>
              <canvas id="pointer" width="220px" height="220px"></canvas>
              <p :class="this.drawDegree == null ? 'noDegree' : ''">
                {{ this.drawDegree == null ? '暂无设置' : this.drawDegree + '℃' }}
                <span class="type" v-if="eqInfo.airVentilator.workingMode1 === '0'"><span>制冷</span></span>
                <span class="type" v-else-if="eqInfo.airVentilator.workingMode1 === '1'"><span>制热</span></span>
                <span class="type" v-else-if="eqInfo.airVentilator.workingMode1 === '2'"><span>通风</span></span>
                <span class="type" v-else><span></span></span>
              </p>
            </div>
            <div class="humidity font">
              <span>湿度</span>
              <span>{{
                  eqInfo.airVentilator.returnAirHumidity == null ? '—' : eqInfo.airVentilator.returnAirHumidity + '%'
                }}</span>
              <br/>
            </div>
            <div v-if="eqInfo.airVentilator.workingMode1 === '1'" class="yh-item font">
              <p>
                <span>制热温度设定</span>
                <span>{{
                    eqInfo.airVentilator.homeHeatingTemperatureSetting != null ? eqInfo.airVentilator.homeHeatingTemperatureSetting + '℃' : '暂无设置'
                  }}</span>
              </p>
              <p>
                <span>制热湿度设定</span>
                <span>{{
                    eqInfo.airVentilator.homeHeatingHumiditySetting != null ? eqInfo.airVentilator.homeHeatingHumiditySetting + '%' : '暂无设置'
                  }}</span>
              </p>
            </div>
            <div v-else-if="eqInfo.airVentilator.workingMode1 === '0'" class="yh-item font">
              <p>
                <span>制冷温度设定</span>
                <span>{{
                    eqInfo.airVentilator.homeCoolingTemperatureSetting != null ? eqInfo.airVentilator.homeCoolingTemperatureSetting + '℃' : '暂无设置'
                  }}</span>
              </p>
              <p>
                <span>制冷湿度设定</span>
                <span>{{
                    eqInfo.airVentilator.homeCoolingHumiditySetting != null ? eqInfo.airVentilator.homeCoolingHumiditySetting + '%' : '暂无设置'
                  }}</span>
              </p>
            </div>
            <!--            <div v-else class="yh-item font">-->
            <!--              <p>-->
            <!--                <span>通风模式</span>-->
            <!--                <span>{{-->
            <!--                    eqInfo.airVentilator.homeCoolingTemperatureSetting != null ? eqInfo.airVentilator.homeCoolingTemperatureSetting + '℃' : '暂无设置'-->
            <!--                  }}</span>-->
            <!--              </p>-->
            <!--              <p>-->
            <!--                <span>通风模式</span>-->
            <!--                <span>{{-->
            <!--                    eqInfo.airVentilator.homeCoolingHumiditySetting != null ? eqInfo.airVentilator.homeCoolingHumiditySetting + '%' : '暂无设置'-->
            <!--                  }}</span>-->
            <!--              </p>-->
            <!--            </div>-->
            <p class="zt">
              <span>系统状态</span>
              <span>
								{{
                  eqInfo.airVentilator.systemStatus1 === '0' ? '关机' :
                      eqInfo.airVentilator.systemStatus1 === '1' ? '关机' :
                          eqInfo.airVentilator.systemStatus1 === '2' ? '关机' :
                              eqInfo.airVentilator.systemStatus1 === '3' ? '关机' :
                                  eqInfo.airVentilator.systemStatus1 === '4' ? '开机' :
                                      eqInfo.airVentilator.systemStatus1 === '5' ? '开机' :
                                          eqInfo.airVentilator.systemStatus1 === '6' ? '开机' :
                                              eqInfo.airVentilator.systemStatus1 === '7' ? '关机' :
                                                  eqInfo.airVentilator.systemStatus1 === '8' ? '关机' :
                                                      eqInfo.airVentilator.systemStatus1 === '9' ? '关机' : '未知状态'
                }}
							</span>
            </p>
          </div>
          <div class="fresh_img"></div>
          <div v-if="this.eqInfo.airVentilator.workingMode1!=='2'" class="fresh_setDegree clear">
            <!--温度设定-->
            <vEqSetDegree :eqInfo="eqInfo" :id="this.getId()" @init="init"></vEqSetDegree>

            <!--湿度设定-->
            <vEqSetHumidity :eqInfo="eqInfo" :id="this.getId()" @init="init"></vEqSetHumidity>
          </div>
        </div>

        <div class="eqComType">
          <ul class="clear">
            <!--开关机-->
            <vEqSwitchMachine :eqInfo="eqInfo" :id="this.getId()" @init="init"></vEqSwitchMachine>

            <!--模式切换-->
            <vEqModal :eqInfo="eqInfo" :id="this.getId()" @init="init"></vEqModal>

            <!--报警-->
            <vEqAlarm :eqInfo="eqInfo" :id="this.getId()" @init="init"></vEqAlarm>

            <!--定时-->
            <vEqTimer :eqInfo="eqInfo" :id="this.getId()" @init="init"></vEqTimer>
          </ul>
        </div>

        <!--        环境空气质量-->
        <div class="eqAir">
          <router-link :to="PATH.goFreshStatus1() + this.getId()">
            <p class="aTitle">环境空气质量</p>
            <ul class="clearfix p-font">
              <li>
                <div>
                  <p class="aName">CO2</p>
                  <p class="aText text-danger">
                    {{ eqInfo && eqInfo.airVentilator.co2 ? eqInfo.airVentilator.co2 : 0 }}
                    <span>ppm</span>
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <p class="aName">TVOC</p>
                  <p class="aText text-success">
                    {{ eqInfo && eqInfo.airVentilator.tvoc ? eqInfo.airVentilator.tvoc : 0 }}
                    <span>mg</span>
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <p class="aName">PM2.5</p>
                  <p class="aText text-blue">
                    {{ eqInfo && eqInfo.airVentilator.pm25 ? eqInfo.airVentilator.pm25 : 0 }}
                    <span>ug</span>
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <p class="aName">甲醛</p>
                  <p class="aText text-orange">
                    {{ eqInfo && eqInfo.airVentilator.formaldehyde ? eqInfo.airVentilator.formaldehyde : 0 }}
                    <span>mg</span>
                  </p>
                </div>
              </li>
            </ul>
          </router-link>
        </div>

        <!--用户参数-->
        <router-link :to="'/fresh/params/' + this.getId()">
          <div class="userParams eq-shandow">
            用户参数模式
            <span class="icon-arrow"></span>
          </div>
        </router-link>
      </div>
    </div>

    <!--解绑弹窗-->
    <div class="tip detail_tip" v-show="showUnBind">
      <div class="content">
        <div class="tip_body">
          <div class="modal-warning">
            <span></span>
            <p>温馨提示：确定解除绑定吗</p>
          </div>
        </div>
        <div class="tip_foot">
          <span @click="hideModalCom('showUnBind')">取消</span>
          <span @click="sureBind">确定</span>
        </div>
      </div>
    </div>
    <div class="userParams eq-shandow">
      <p>
        场景
        <span class=" right yh">
					<span class="yh2">{{ eqInfo.sceneName }}</span>
					{{ eqInfo.roomName }}
					<i class="icon-edit" @click="chooseScene"></i>
				</span>
      </p>
    </div>
  </div>
</template>
<script>
// import Swiper from 'swiper';
// import 'swiper/dist/css/swiper.css';
import {Range, Toast, Popup, Radio, Indicator} from 'mint-ui';
import PATH from '../../../router/path';

import EqSwitchMachine from '../../commen/eqSwitchMachine/index';
import EqModal from '../../commen/eqModal/index';
import EqAlarm from '../../commen/eqAlarm/index';
import EqTimer from '../../commen/eqTimer/index';
import EqSetDegree from '../../commen/eqSetDegree/index';
import EqSetHumidity from '../../commen/eqSetHumidity/index';

export default {
  name: 'detail',
  components: {
    vEqSwitchMachine: EqSwitchMachine,
    vEqModal: EqModal,
    vEqAlarm: EqAlarm,
    vEqTimer: EqTimer,
    vEqSetDegree: EqSetDegree,
    vEqSetHumidity: EqSetHumidity
  },
  data() {
    return {
      rangeValue: 50,
      showRange: false,
      list: [],
      showMenu: false,
      showTip: false,
      eqId: this.$route.params.id,
      totalDegree: 45,
      eqInfo: {
        airVentilator: {}
      },
      eqModeVal: null,
      equipmentFanMode: 1, //(1:on 0:自动 2:循环 3: 低速 4: 中速 5: 高速)
      degrees: 0,
      popupVisible: false,
      eqFlag: 1,
      stopRequest: false,
      showModel: false,
      alreadyLoad: false,
      value: '2',
      showDegrees: false,
      valueDegrees: null,
      roomTep: null,
      firstRequest: true,
      isRequest: true,
      showEmpty: false,
      showUnBind: false,

      // path: this.$websocketUrl,
      // path: "ws://www.192.168.1.103:80/auto-equipment/websocketDemo/",
      socket: '',
      drawDegree: null,
      showFreshDegrees: false,
      eqParams: {},
      guzhang: 0
    };
  },
  beforeMount() {
    let num = this.totalDegree;
    let list = [];
    for (let i = 0; i < num; i++) {
      list.push(i);
    }
    this.list = list;
  },
  mounted() {
    this.isRequest = true;
    this.closeTimer = null;
    this.drawDegree = null;
    this.init();
  },
  methods: {
    init() {
      this.drawCircle();
      if (this.getId()) {
        this.eqDetail(this.eqId);
      }
    },
    getId() {
      return this.$route.params.id;
    },

    initDraw() {
      let degrees = this.drawDegree;
      if (degrees || degrees == 0) {
        this.drawPointer(degrees);
        this.drawGreenCricle(degrees);
        this.drawCircle(degrees);
      }
    },
    eqDetail(id) {
      this.Api.eqDetail(
          id,
          (msg) => {
            //初始化websocket
            if (typeof WebSocket === 'undefined') {
              alert('您的浏览器不支持socket');
            } else {
              // 实例化socket
              this.socket = this.$store.state.websocket
              if (!this.socket) {
                this.socket = new WebSocket(this.$websocketUrl + id);
              }
              // 监听socket连接
              this.socket.onopen = this.socketopen;
              // 监听socket错误信息
              this.socket.onerror = this.socketerror;
              // 监听socket消息
              this.socket.onmessage = this.getMessage;
              // 关闭socket消息
              this.socket.onclose = this.socketclose;
              this.$store.commit('setWebSocket', this.socket);
            }
            this.alreadyLoad = true;
            if (msg.data) {
              this.eqInfo = msg.data;
              if (this.eqInfo.airVentilator){
                // 获取设定温度
                /*制冷*/
                if (msg.data.workingMode1 === '0') {
                  this.degrees = msg.data.airVentilator.homeCoolingTemperatureSetting;
                }

                /*制热*/
                if (msg.data.workingMode1 === '1') {
                  this.degrees = msg.data.airVentilator.homeHeatingTemperatureSetting;
                }

                let arrD = [];
                arrD.push(this.degrees);
                this.valueDegrees = arrD;

                this.eqModeVal = String(msg.data.workingMode1);
                let arr = [];

                if (msg.data.equipmentRoomTemperature) {
                  let roomTep = Number(msg.data.equipmentRoomTemperature);
                  let arr = [];
                  for (let i = -2; i < 3; i++) {
                    arr.push(roomTep + i);
                  }
                  this.roomTep = arr;
                }

                // 温度仪表盘温度
                this.drawDegree = msg.data.airVentilator.returnAirTemperature;

              }else {
                this.eqInfo.airVentilator ={
                  workingMode1: '0',
                }
              }

              this.initDraw();
            } else {
              this.showEmpty = true;
            }
          }
      );
    },
    eqDel() {
      let params = {};
      params.id = this.eqId;
      this.Api.eqDel(params, msg => {
        if (msg.code == 200) {
          let str = 'pageNo=1';
          this.eqList(str);
        } else {
          Toast(msg.message);
        }
      });
    },

    hideSomething() {
      this.showRange = false;
      this.showMenu = false;
    },
    changeMenu(e) {
      e.stopPropagation();
      this.showMenu = !this.showMenu;
    },
    drawCircle() {
      var canvas = document.getElementById('clock');
      var ctx = canvas.getContext('2d');
      // 绘制外环
      ctx.beginPath();
      ctx.arc(110, 110, 85, (45 / 180) * Math.PI, (135 / 180) * Math.PI, true);
      ctx.strokeStyle = 'rgba(255,255,255,0.15)';
      ctx.lineWidth = '1';
      ctx.stroke();
      ctx.closePath();
      // 绘制灰色内环
      ctx.beginPath();
      ctx.arc(110, 110, 100, (45 / 180) * Math.PI, (135 / 180) * Math.PI, true);
      ctx.strokeStyle = 'rgba(255,255,255,0.3)';
      ctx.lineWidth = '5';
      ctx.stroke();
      ctx.closePath();
    },
    drawGreenCricle(val) {
      var canvas = document.getElementById('clock');
      var ctx = canvas.getContext('2d');
      canvas.height = canvas.height;
      let total = this.totalDegree;
      let rate = val / total;
      // 绘制绿色内环
      ctx.beginPath();
      ctx.arc(110, 110, 100, 0.75 * Math.PI, (1.5 * rate + 0.75) * Math.PI, false);
      ctx.strokeStyle = '#38FFEE';
      ctx.lineWidth = '5';
      ctx.stroke();
      ctx.closePath();
    },
    drawPointer(val) {
      var canvas = document.getElementById('pointer');
      var ctx = canvas.getContext('2d');
      canvas.height = canvas.height;

      // 绘制外环
      let i = -val;
      let deg = (360 / 60) * i;
      let total = 15;
      deg = deg + 45;

      ctx.beginPath();
      ctx.translate(canvas.width / 2, canvas.height / 2);
      let r = 100;
      let x = -Math.cos((Math.PI / 180) * deg) * r;
      let y = Math.sin((Math.PI / 180) * deg) * r;
      ctx.arc(x, y, 10, 0, 2 * Math.PI, true);
      ctx.fillStyle = '#38FFEE';
      ctx.fill();
      ctx.closePath();
    },
    eqUnbind() {
      this.showModalCom('showUnBind');
    },
    sureBind() {
      let data = {
        "iotDeviceId": this.getId()
      }
      this.Api.eqUnbind(data, msg => {
        this.showUnBind = false;
        if (msg.code == 200) {
          localStorage.setItem('isLo', 1);
          Toast('设备解绑成功');
          this.$router.push({path: '/equipment'});
        }
        if (msg.code == 402) {
          Toast(msg.message);
        }
      });
    },
    goBack() {
      this.$router.push({path: '/equipment'});
    },
    hideModalCom(key) {
      this.showUnBind = false;
    },
    showModalCom(key) {
      this[key] = true;
    },
    socketopen: function () {
      console.log('socket连接成功');
      console.log();
    },
    socketerror: function () {
      console.log('连接错误');
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data);
      if (data.pm25 !== undefined) {
        this.eqInfo.airVentilator.pm25 = data.pm25
      }
      if (data.co2 !== undefined) {
        this.eqInfo.airVentilator.co2 = data.co2
      }
      if (data.tvoc !== undefined) {
        this.eqInfo.airVentilator.tvoc = data.tvoc
      }
      if (data.formaldehyde !== undefined) {
        this.eqInfo.airVentilator.formaldehyde = data.formaldehyde
      }
      if (data.systemStatus1 !== undefined) {
        this.eqInfo.airVentilator.systemStatus1 = data.systemStatus1
      }
      if (data.workingMode1 !== undefined) {
        this.eqInfo.airVentilator.workingMode1 = data.workingMode1
      }
      if (data.homeHeatingTemperatureSetting !== undefined) {
        this.eqInfo.airVentilator.homeHeatingTemperatureSetting = data.homeHeatingTemperatureSetting
      }
      if (data.handlerHomeHeatingHumiditySetting !== undefined) {
        this.eqInfo.airVentilator.handlerHomeHeatingHumiditySetting = data.homeHeatingHumiditySetting
      }
      if (data.homeCoolingTemperatureSetting !== undefined) {
        this.eqInfo.airVentilator.homeCoolingTemperatureSetting = data.homeCoolingTemperatureSetting
      }
      if (data.homeCoolingHumiditySetting !== undefined) {
        this.eqInfo.airVentilator.homeCoolingHumiditySetting = data.homeCoolingHumiditySetting
      }
      if (data.returnAirHumidity !== undefined) {
        this.eqInfo.airVentilator.returnAirHumidity = data.returnAirHumidity
      }
      if (data.returnAirTemperature !== undefined) {
        this.eqInfo.airVentilator.returnAirTemperature = data.returnAirTemperature
        this.drawDegree = this.eqInfo.airVentilator.returnAirTemperature
      }

    },
    socketclose: function () {
      console.log('socket已经关闭');
      this.socket.close();
    },
    chooseScene() {
      this.$router.push({path: this.PATH.getChooseHome() + '2?id=' + this.getId()});
    }
  }
};
</script>
<style scoped>
@import url('../../../assets/list.css');
@import url('../../equipment/detail/detail.css');
@import url('./index.css');

.noDegree {
  font-size: 23px !important;
}

.yh-item {
  padding-top: 5px;
  text-align: center;
  color: #ffffff;
  position: inherit;
}

.font {
  font-size: 19px;
}

.zt {
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  position: inherit;
}

.yh {
  display: inline-block;
  max-width: 85%;
  text-align: right;
}

.yh2 {
  display: inline-block;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.p-font p {
  font-size: 15px;
}

.p-font span {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/freshAir/detail/index.vue